<a *ngIf="email && !hide" class="email" href="mailto:{{ email }}">
    <i class="fas fa-envelope icon"></i> 
    <span>{{ email }}</span>
</a>